import { render } from "./serviceBtn.vue?vue&type=template&id=535af52a&scoped=true&bindings={}"
import script from "./serviceBtn.vue?vue&type=script&lang=js"
export * from "./serviceBtn.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-535af52a"

export default script